export default "__VITE_ASSET__B5LsVv0j__"